export const AUTH_MODE_KEY = 'auth_mode';

export const AUTH_MODE = {
    LEGACY: 'legacy',
    SSO: 'sso',
};

export const AUTH_STORAGE_KEYS = [
    'token',
    'username',
    'tenant',
    'tenantId',
    'tid',
    'tenantType',
    'schoolYear',
    'schoolYears',
    'keycloakToken',
    'keycloakRefreshToken',
    'keycloakIdToken',
    AUTH_MODE_KEY,
];

export const setAuthMode = mode => localStorage.setItem(AUTH_MODE_KEY, mode);
export const getAuthMode = () => localStorage.getItem(AUTH_MODE_KEY);
export const clearAuthMode = () => localStorage.removeItem(AUTH_MODE_KEY);

export const setToken = token => localStorage.setItem('token', token);
export const getToken = () => localStorage.getItem('token');
export const clearToken = () => localStorage.removeItem('token');

export const clearAuthSession = () => {
    AUTH_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
};

export const getUsernameFromDecodedToken = decoded =>
    decoded?.sub || decoded?.username || decoded?.user_name || decoded?.preferred_username || '';

export const storeAppSession = (token, decoded, mode) => {
    clearAuthSession();
    if (mode) {
        setAuthMode(mode);
    }
    localStorage.setItem('token', token);
    localStorage.setItem('username', getUsernameFromDecodedToken(decoded));
    localStorage.setItem('tenant', decoded?.tenant || '');
    localStorage.setItem('tenantId', decoded?.tenantId || '');
    localStorage.setItem('tid', decoded?.tid || '');
    localStorage.setItem('tenantType', decoded?.tenantType || '');
};
